import studentApi from "./studentApi";
import { STUDENT_ENDPOINTS } from "./studentEndpoints";

// Confirmed by the user (2026-10-27): the previous `result-view` endpoint
// (separate static token, no `/api` prefix) had no CORS headers at all and
// used an expired hardcoded JWT, so it could never succeed from the browser.
// This route lives under the normal `student/*` prefix instead, so it goes
// through studentApi.js and is authenticated with the logged-in student's
// own token like every other student-portal API call.
//
// Cache-busting headers + the `t` query param so a re-download after a
// result gets republished never serves a stale cached PDF. `send_s3` is
// always 0 — the student portal only wants the file back in the response,
// not also pushed to S3.
export const downloadResult = (sessionId, term) => {
  const url = `${STUDENT_ENDPOINTS.RESULT.DOWNLOAD}/${sessionId}/${term}/0`;
  return studentApi.get(url, {
    headers: {
      "Cache-Control": "no-cache, no-store, must-revalidate",
      Pragma: "no-cache",
      Expires: "0",
    },
    params: {
      t: new Date().getTime(),
    },
    responseType: "arraybuffer",
  });
};
